import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import Link from "@mui/material/Link";
import type { SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { misc, neutral, primary } from "app/themes/colors";

type CommentsLinkProps = {
  taskId: number;
  count: number;
  isComplete: boolean;
  sx?: SxProps;
  onClick?: (taskId: number) => void;
};
export default function CommentsLink({
  taskId,
  count,
  isComplete,
  sx,
  onClick,
}: CommentsLinkProps) {
  const hasComments = count > 0;
  return (
    <Box mt={1} sx={sx}>
      <Link
        sx={{
          cursor: "pointer",
        }}
        onClick={(event) => {
          event.preventDefault();
          onClick?.(taskId);
        }}
      >
        <Badge
          sx={{
            "& .MuiBadge-anchorOriginTopRight": {
              background: isComplete ? grey[500] : misc.sunoGreen,
              opacity: hasComments ? 1 : 0,
              mt: 0,
              mr: count < 10 ? -2.8 : count < 100 ? -3.3 : -4,
              transform: "scale(0.8)",
            },
          }}
          badgeContent={hasComments ? count : ""}
          color="primary"
        >
          <Typography
            variant="body1"
            fontSize={12}
            sx={{
              letterSpacing: 0.7,
              textDecoration: "underline",
              color: isComplete ? grey[700] : misc.sunoGreen,

              "&:hover": {
                color: hasComments ? primary[500] : neutral[800],
                textDecorationColor: hasComments
                  ? misc.sunoGreen
                  : neutral[500],
              },
              textDecorationColor: hasComments ? misc.darkGreen : neutral[500],
            }}
          >
            {hasComments ? "View Comments" : "+ Add Comment"}
          </Typography>
        </Badge>
      </Link>
    </Box>
  );
}
